var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeerSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1028_4974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1028_4974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 39H31V17.5H26.5C25.5667 17.5 24.7833 17.7583 24.15 18.275C23.5167 18.7917 22.8 19.5 22 20.4C21.1333 21.3667 20.1833 22.2167 19.15 22.95C18.1167 23.6833 17.0667 24.1833 16 24.45V39ZM13 42V24.4C11.2667 23.9333 9.75 23.05 8.45 21.75C7.15 20.45 6.5 18.8667 6.5 17C6.5 15.2333 7.00833 13.6583 8.025 12.275C9.04167 10.8917 10.35 9.93333 11.95 9.4C12.7167 7.8 13.8583 6.5 15.375 5.5C16.8917 4.5 18.6 4 20.5 4C21.6667 4 22.7583 4.2 23.775 4.6C24.7917 5 25.7167 5.55 26.55 6.25C26.8833 6.18333 27.2 6.125 27.5 6.075C27.8 6.025 28.1333 6 28.5 6C30.7 6 32.5833 6.78333 34.15 8.35C35.7167 9.91667 36.5 11.8 36.5 14C36.5 14.7333 36.35 15.4667 36.05 16.2C35.75 16.9333 35.3667 17.5333 34.9 18H39.5C40.3333 18 41.0417 18.2917 41.625 18.875C42.2083 19.4583 42.5 20.1667 42.5 21V35C42.5 35.8333 42.2083 36.5417 41.625 37.125C41.0417 37.7083 40.3333 38 39.5 38H34V42H13ZM9.5 17C9.5 18.2667 10.0167 19.3333 11.05 20.2C12.0833 21.0667 13.2333 21.5 14.5 21.5C15.5667 21.5 16.5333 21.2083 17.4 20.625C18.2667 20.0417 19.15 19.2 20.05 18.1C20.8167 17.1667 21.7333 16.3333 22.8 15.6C23.8667 14.8667 25.1 14.5 26.5 14.5H33.5C33.5 13 33.0583 11.7083 32.175 10.625C31.2917 9.54167 30.0667 9 28.5 9C27.9 9 27.3083 9.09167 26.725 9.275L25.85 9.55L24.9 8.75C24.3 8.21667 23.6167 7.79167 22.85 7.475C22.0833 7.15833 21.3 7 20.5 7C19.3333 7 18.2167 7.3 17.15 7.9C16.0833 8.5 15.3 9.33333 14.8 10.4L14.1 11.9L12.5 12.45C11.6333 12.75 10.9167 13.35 10.35 14.25C9.78333 15.15 9.5 16.0667 9.5 17ZM34 35H39.5V21H34V35Z",
    fill: "#E1E1E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeerSubscription);
export default __webpack_public_path__ + "static/media/beer_subscription.c01eb4a2bb411dc9205567321f534230.svg";
export { ForwardRef as ReactComponent };